<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>

<div *ngIf="useMobileView">

  <div class="mob-toolbar">
    <div class="mob-toolbar-inner">

      <div class="mob-search-wrap">
        <span class="p-input-icon-left mob-search-input-wrap">
          <i class="pi pi-search"></i>
          <input class="mob-search-input" pInputText type="text"
                 placeholder="Search bookings"
                 [(ngModel)]="searchCriteria"
                 (keyup.enter)="getSearchResults()"/>
        </span>
        <button class="mob-search-btn" type="button" (click)="getSearchResults()">
          <i class="pi pi-search"></i>
        </button>
      </div>

      <div class="mob-date-nav">
        <button pButton pTooltip="Previous day"
                class="p-button decrementButton mob-nav-btn"
                (click)="dateChange(-1)">
          <span class="pi pi-angle-left"></span>
        </button>
        <div class="mob-cal-wrap">
          <p-calendar [selectOtherMonths]="true"
                      [(ngModel)]="BookingDate" firstDayOfWeek="1"
                      dateFormat="dd/mm/yy"
                      (onSelect)="doneDate()" (onChange)="doneDate()">
          </p-calendar>
        </div>
        <button pButton pTooltip="Next day"
                class="p-button incrementButton mob-nav-btn"
                (click)="dateChange(1)">
          <span class="pi pi-angle-right"></span>
        </button>
      </div>

      <div class="mob-counters">
        <button pButton type="button" pTooltip="Bookings in progress"
                class="p-button-sm p-button-warning mob-counter-btn"
                (click)="showInProgress()">
          <span class="pi pi-clock"></span>
          <span>{{bookingsInProgress}}</span>
        </button>
        <button pButton type="button" pTooltip="Bookings today"
                class="p-button-sm p-button-success mob-counter-btn"
                (click)="unshowInProgress()">
          <span class="pi pi-check-circle"></span>
          <span>{{totalBookingsToday}}</span>
        </button>
      </div>

    </div>
  </div>

  <div class="surface-card shadow-2">
    <p-table [value]="ListBookings"
             sortField="startTime"
             [paginator]="true"
             [rows]="10"
             [showCurrentPageReport]="true"
             currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
             [rowsPerPageOptions]="[10,25,50]"
             [globalFilterFields]="['name','bookingId','bookingIdHR','packageName']"
             responsiveLayout="scroll"
             styleClass="mob-booking-table">

      <ng-template pTemplate="header">
        <tr>
          <th class="mob-stripe-th"></th>
          <th pSortableColumn="startTime">Booking</th>
          <th pSortableColumn="total" style="text-align:right">Amount</th>
          <th style="width:48px"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-data>
        <tr [ngStyle]="{'background-color': data.disabled ? '#fff1f2' : ((data.allergy != null && data.allergy != '') && !data.inProgress ? '#FFFFB2' : '#ffffff')}"
            [class.mob-data-row]="!data.inProgress || inProgress"
            [class.mob-data-row--inprogress]="data.inProgress && inProgress"
            *ngIf="(!data.inProgress && !inProgress) || (data.inProgress && inProgress)"
            (click)="editdatanew(data.bookingId)">

          <!-- Coloured status stripe -->
          <td class="mob-status-stripe"
              [ngStyle]="{'background-color': data.disabled ? '#ef4444' : ((data.allergy != null && data.allergy != '') ? '#d97706' : data.inProgress ? '#f59e0b' : '#94a3b8')}">
          </td>

          <!-- 2-line main cell -->
          <td class="mob-main-cell">
            <div class="mob-main-line1">
              <span class="mob-time">{{data.startTime | date:'HH:mm' : 'UTC'}}</span>
              <span class="mob-name">{{data.name}}</span>
              <span class="mob-inline-icons">
                <i *ngIf="data.publicBooking"   class="pi pi-user              mob-iico"></i>
                <i *ngIf="data.awaitingpayment" class="pi pi-dollar            mob-iico mob-iico--red" pTooltip="Payment link sent"></i>
                <i *ngIf="data.notes"           class="pi pi-exclamation-circle mob-iico mob-iico--red" [pTooltip]="data.notes"></i>
                <i *ngIf="data.disabled"        class="pi pi-ban               mob-iico mob-iico--red"></i>
                <i *ngIf="data.allergy"         class="pi pi-star              mob-iico mob-iico--amber"></i>
                <i *ngIf="data.seriesid"        class="pi pi-sync              mob-iico" pTooltip="One of a series of repeat bookings"></i>
              </span>
            </div>
            <div class="mob-main-line2">
              <span class="mob-bookingid">{{data.bookingIdHR}}</span>
              <span class="mob-pkg" *ngIf="data.packageName">&nbsp;&middot;&nbsp;{{data.packageName}}</span>
              <span class="mob-guests" *ngIf="data.guests">&nbsp;&middot;&nbsp;{{data.guests}} guest{{data.guests != 1 ? 's' : ''}}</span>
            </div>
          </td>

          <!-- Stacked money -->
          <td class="mob-money-cell">
            <div class="mob-total">{{data.total | currency: (data.currency || CurrencySymbol)}}</div>
            <div [class.mob-os--overdue]="data.outstanding > 0" [class.mob-os--paid]="data.outstanding <= 0">
              {{data.outstanding | currency: (data.currency || CurrencySymbol)}}
            </div>
          </td>

          <!-- Row actions -->
          <td class="mob-action-cell" (click)="$event.stopPropagation()">
            <button pButton type="button"
                    class="p-button-text p-button-plain mob-action-btn"
                    icon="pi pi-ellipsis-v"
                    (click)="selectedAction = data; rowActionPanel.toggle($event)">
            </button>
          </td>

        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-overlayPanel #rowActionPanel appendTo="body">
    <ng-template pTemplate>
      <div class="mob-action-list">
        <button pButton type="button" class="p-button-outlined mob-action-item"
                icon="pi pi-pencil" label="Edit Booking"
                (click)="editdatanew(selectedAction?.bookingId); rowActionPanel.hide()">
        </button>
        <button pButton type="button" class="p-button-outlined mob-action-item"
                icon="pi pi-envelope" label="Send Confirmation"
                (click)="emailConf(selectedAction?.bookingId); rowActionPanel.hide()">
        </button>
        <button pButton type="button" class="p-button-outlined p-button-danger mob-action-item"
                icon="pi pi-trash" label="Disable Booking"
                *ngIf="!selectedAction?.disabled"
                (click)="disableData(selectedAction?.bookingId); rowActionPanel.hide()">
        </button>
        <button pButton type="button" class="p-button-outlined p-button-success mob-action-item"
                icon="pi pi-check" label="Enable Booking"
                *ngIf="selectedAction?.disabled"
                (click)="undisableData(selectedAction?.bookingId); rowActionPanel.hide()">
        </button>
      </div>
    </ng-template>
  </p-overlayPanel>

</div>

<div *ngIf="!useMobileView">
    <div *ngIf="ListBookings && AccessAllowed" class="p-3 flex flex-column flex-auto">
        <h3 style="margin: 0 0 8px 0;" i18n>Bookings Created: </h3>
        <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 6px; margin-bottom: 20px;">
            <button pButton type="button" pTooltip="Previous day" style="height: 50px; width: 53px; flex-shrink: 0;" (click)="dateChange(-1);" class="p-button-sm p-element p-ripple p-button p-component">
                <span class="pi pi-angle-left"></span>
            </button>
            <div style="flex-shrink: 0; width: 180px;">
                <p-calendar [selectOtherMonths]="true" [(ngModel)]="BookingDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="doneDate()" (onChange)="doneDate()"></p-calendar>
            </div>
            <button pButton type="button" pTooltip="Next day" style="height: 50px; width: 53px; flex-shrink: 0;" (click)="dateChange(1);" class="p-button-sm p-element p-ripple p-button p-component">
                <span class="pi pi-angle-right"></span>
            </button>
            <p-toggleButton pTooltip="Show disabled bookings" *ngIf="!inProgress" class="p-button-sm p-button-danger p-component" [(ngModel)]="isDisabled" offIcon="pi pi-eye-slash" onIcon="pi pi-eye" [style]="{'color':'white','background-color':'#EF4444','font-weight':'normal','height':'50px','flex-shrink':'0'}" (click)="toggleDisabled()">
            </p-toggleButton>
            <div style="margin-left: auto; display: flex; align-items: center; gap: 6px; flex-shrink: 0;">
                <button pTooltip="Bookings in progress" pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-warning p-button p-component" (click)="showInProgress()">
                    <span class="pi pi-clock" style="margin-right:8px; font-size: 16px;"></span>
                    <span style="font-size:17px;">{{bookingsInProgress}}</span>
                </button>
                <button pTooltip="Bookings made today" pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="unshowInProgress()">
                    <span class="pi pi-check-circle" style="margin-right:8px; font-size: 16px;"></span>
                    <span style="font-size:17px;">{{totalBookingsToday}}</span>
                </button>
            </div>
        </div>

        <div class="surface-card p-4 shadow-2 border-round" style="overflow-x: auto;">
    <p-table  #resourceTable
    [columns]="cols"
    [value]="ListBookings" sortField="startTime" [paginator]="true" [rows]="10"
    [showCurrentPageReport]="true" responsiveLayout="scroll"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
    [rowsPerPageOptions]="[10,25,50]"
    [globalFilterFields]="['name', 'bookingId', 'bookingIdHR', 'packageName']"
    [(selection)]="selectedItems"
    responsiveLayout="scroll"
    [selectionPageOnly]="true"
    [customSort]="true"
    (sortFunction)="customSort($event)"
    >
    <ng-template pTemplate="caption">
        <div class="flex">
        <button
            type="button"
            pButton
            pRipple
            icon="pi pi-file-excel"
            (click)="resourceTable.exportCSV()"
            class="mr-2"
            pTooltip="Export to CSV"
            tooltipPosition="bottom">
        </button>
        <!-- &nbsp;
        <button
            type="button"
            pButton
            pRipple
            icon="pi pi-refresh"
            (click)="refreshData()"
            class="mr-2 p-button-info"
            pTooltip="Refresh Data"
            tooltipPosition="bottom">
        </button> -->
        </div>
    </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th width="1%">
                    &nbsp;
                </th>
                <th width="1%">
                    &nbsp;
                </th>
                <th width="1%">
                    &nbsp;
                </th>
                <th width="1%">
                    &nbsp;
                </th>
                <th pSortableColumn="bookingId" width="8%">Sales ID
                    <p-sortIcon [field]="bookingIdHR"></p-sortIcon>
                </th>
                <th pSortableColumn="startTime" width="10%">Start Date
                    <p-sortIcon [field]="startTime"></p-sortIcon>
                </th>
                <th pSortableColumn="startTime" width="3%">Start
                    <p-sortIcon [field]="startTime"></p-sortIcon>
                </th>
                <th pSortableColumn="name" width="10%">Name
                    <p-sortIcon [field]="name"></p-sortIcon>
                </th>

                <th pSortableColumn="name" width="18%">Admissions
                    <p-sortIcon [field]="admissions"></p-sortIcon>
                </th>
                <th pSortableColumn="packageName" width="13%">Package
                    <p-sortIcon [field]="packageName"></p-sortIcon>
                </th>
                <th pSortableColumn="resourcestring" width="10%">Resource
                    <p-sortIcon field="resourcestring"></p-sortIcon>
                </th>
                <th pSortableColumn="guests" width="6%">Guests
                    <p-sortIcon [field]="guests"></p-sortIcon>
                </th>
                <th pSortableColumn="total" width="5%">Total
                    <p-sortIcon [field]="total"></p-sortIcon>
                </th>
                <th pSortableColumn="outstanding" width="5%">O/S
                    <p-sortIcon [field]="outstanding"></p-sortIcon>
                </th>

                <th width="15%">
                    Extras
                </th>

                <th width="10%">
                    Allergy
                </th>
                <th *ngIf="useCounters" width="5%"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr *ngIf="!data.inProgress && !inProgress  && (data.allergy == '' || data.allergy == null)" onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                <td (click)="editdatanew(data.bookingId)" >
                    <span *ngIf="data.publicBooking" class="pi pi-user"></span> 
                </td>
                <td (click)="editdatanew(data.bookingId)">
                    <span style="color:red" *ngIf="data.notes != '' && data.notes != null" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span> 
                </td>
                <td>
                    <span style="color:red" *ngIf="data.awaitingpayment" class="pi pi-dollar" pTooltip="A payment link has been sent for this booking."></span> 
                </td>
                <td (click)="editdatanew(data.bookingId)">
                    <!-- A repeatable package books one date per booking, all sharing a seriesid. -->
                    <span *ngIf="data.seriesid" class="pi pi-sync" pTooltip="One of a series of repeat bookings"></span>
                </td>
                <td (click)="editdatanew(data.bookingId)">{{data.bookingIdHR}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'dd/MM/yy'}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.name}} ({{maskMobile(data.phone)}})</td>
                <td (click)="editdatanew(data.bookingId)">{{data.admissions}}</td>
                <!-- <td (click)="editdatanew(data.bookingId)">{{data.email}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.phone}}</td> -->
                <td (click)="editdatanew(data.bookingId)">{{data.packageName}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.resourcestring}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.guests}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
                <td (click)="editdatanew(data.bookingId)" *ngIf="data.outstanding <=0">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
                <td (click)="editdatanew(data.bookingId)" *ngIf="data.outstanding >0"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
                <td (click)="editdatanew(data.bookingId)">{{data.extrastext}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.allergy}}</td>
            </tr>

            <tr *ngIf="data.inProgress && inProgress" onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                <td (click)="editdatanew(data.bookingId)" >
                    <span *ngIf="data.publicBooking" class="pi pi-user"></span> 
                </td>
                <td (click)="editdatanew(data.bookingId)">
                    <span style="color:red" *ngIf="data.notes != '' && data.notes != null" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span> 
                </td>
                <td>
                    <span style="color:red" *ngIf="data.awaitingpayment" class="pi pi-dollar" pTooltip="A payment link has been sent for this booking."></span> 
                </td>
                <td (click)="editdatanew(data.bookingId)">
                    <!-- A repeatable package books one date per booking, all sharing a seriesid. -->
                    <span *ngIf="data.seriesid" class="pi pi-sync" pTooltip="One of a series of repeat bookings"></span>
                </td>
                <td style="cursor:not-allowed">{{data.bookingIdHR}}</td>
                <td style="cursor:not-allowed">{{data.startTime | date:'dd/MM/yy'}}</td>
                <td style="cursor:not-allowed">{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                <td style="cursor:not-allowed">{{data.name}} ({{data.phone}})</td>
                <td style="cursor:not-allowed">{{data.admissions}}</td>
                <td style="cursor:not-allowed">{{data.packageName}}</td>
                <td style="cursor:not-allowed">{{data.resourcestring}}</td>
                <td style="cursor:not-allowed">{{data.guests}}</td>
                <td style="cursor:not-allowed">{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
                <td style="cursor:not-allowed" *ngIf="data.outstanding <=0">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
                <td style="cursor:not-allowed" *ngIf="data.outstanding >0"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
                <td style="cursor:not-allowed">{{data.extrastext}}</td>
                <td style="cursor:not-allowed">{{data.allergy}}</td>
            </tr>

            <tr *ngIf="!data.inProgress && !inProgress && data.allergy != '' && data.allergy != null" onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#FFFFB2'}">
                <td (click)="editdatanew(data.bookingId)" >
                    <span *ngIf="data.publicBooking" class="pi pi-user"></span> 
                </td>
                <td (click)="editdatanew(data.bookingId)">
                    <span style="color:red" *ngIf="data.notes != '' && data.notes != null" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span> 
                </td>
                <td>
                    <span style="color:red" *ngIf="data.awaitingpayment" class="pi pi-dollar" pTooltip="A payment link has been sent for this booking."></span> 
                </td>
                <td (click)="editdatanew(data.bookingId)">
                    <!-- A repeatable package books one date per booking, all sharing a seriesid. -->
                    <span *ngIf="data.seriesid" class="pi pi-sync" pTooltip="One of a series of repeat bookings"></span>
                </td>
                <td (click)="editdatanew(data.bookingId)">{{data.bookingIdHR}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'dd/MM/yy'}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.name}} ({{data.phone}})</td>
                <td (click)="editdatanew(data.bookingId)">{{data.admissions}}</td>
                <!-- <td (click)="editdatanew(data.bookingId)">{{data.email}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.phone}}</td> -->
                <td (click)="editdatanew(data.bookingId)">{{data.packageName}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.resourcestring}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.guests}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
                <td (click)="editdatanew(data.bookingId)" *ngIf="data.outstanding <=0">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
                <td (click)="editdatanew(data.bookingId)" *ngIf="data.outstanding >0"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
                <td (click)="editdatanew(data.bookingId)">{{data.extraslist}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.allergy}}</td>

            </tr>
        </ng-template>
    </p-table>

            <!-- <button pButton type="button" class="p-button-sm p-element p-ripple p-button p-component" (click)="exportData()" i18>
                <span class="pi pi-plus"></span> Export this data
            </button> -->
        </div>
    </div>
</div>